import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  border: 1px solid ${(p) => p.theme.tableRowBorder};
  border-radius: 16px;
  overflow: hidden;
`

export const ScrollArea = styled.div`
  width: 100%;

  @media screen and (max-width: 1100px) {
    overflow-x: auto;
  }
`

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.875rem;
  color: ${(p) => p.theme.textColor};
`

export const HeaderRow = styled.tr`
  background: ${(p) => p.theme.colorSurface2};
`

export const BodyRow = styled.tr<{ $clickable?: boolean }>`
  background: ${(p) => p.theme.colorSurface1};
  cursor: ${(p) => (p.$clickable ? 'pointer' : 'default')};
  &:hover {
    background: ${(p) => p.theme.glassHover};
  }
`

interface CellProps {
  $align?: 'left' | 'center' | 'right'
  $sortable?: boolean
}

export const Th = styled.th<CellProps>`
  text-align: ${(p) => p.$align ?? 'left'};
  padding: 0.6rem 0.8rem;
  font-weight: 600;
  border-bottom: 1px solid ${(p) => p.theme.colorDividerDefault};
  cursor: ${(p) => (p.$sortable ? 'pointer' : 'default')};
  user-select: none;
  white-space: nowrap;
`

export const StickyTh = styled(Th)`
  position: sticky;
  left: 0;
  background: ${(p) => p.theme.colorSurface1};
  z-index: 2;
`

export const Td = styled.td<CellProps>`
  text-align: ${(p) => p.$align ?? 'left'};
  padding: 0.6rem 0.8rem;
  border-bottom: 1px solid ${(p) => p.theme.colorDividerDefault};
  vertical-align: middle;
`

export const StickyTd = styled(Td)`
  position: sticky;
  left: 0;
  background: ${(p) => p.theme.colorSurface1};
  z-index: 1;
`

export const SortIndicator = styled.span`
  margin-left: 0.4rem;
  font-size: 0.7rem;
  color: ${(p) => p.theme.colorOrange};
`

export const MenuCell = styled.td`
  position: relative;
  z-index: 10;
  border-bottom: 1px solid ${(p) => p.theme.tableRowBorder};
  vertical-align: middle;
  width: 3rem;
  padding: 0;
`

export const EmptyCell = styled.td`
  text-align: center;
  padding: 2rem;
  color: ${(p) => p.theme.textFaded};
`

export const TableControls = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0.5rem 0.8rem;
`

export const ToggleWrapper = styled.div`
  position: relative;
`

export const ColumnsButton = styled.button`
  background: none;
  border: none;
  color: ${(p) => p.theme.colorOrange};
  font-size: 14px;
  cursor: pointer;
  padding: 0.25rem 0.5rem;

  &:hover {
    text-decoration: underline;
  }
`

export const ColumnsDropdown = styled.div`
  position: absolute;
  right: 0;
  top: 100%;
  margin-top: 0.5rem;
  z-index: 100;
  min-width: 14rem;
  padding: 0.75rem;
  border-radius: 12px;
  border: 1px solid ${(p) => p.theme.colorDividerDefault};
  background-color: ${(p) => p.theme.colorSurfaceBase};
  ${(p) => p.theme.content};
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`

export const ShowAllButton = styled.button`
  background: none;
  border: none;
  color: ${(p) => p.theme.colorOrange};
  font-size: 14px;
  cursor: pointer;
  padding: 0.75rem 0.5rem;
  text-align: left;
  border-bottom: 1px solid ${(p) => p.theme.colorDividerDefault};
  margin-bottom: 0.25rem;
`

export const ColumnToggleItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 0.5rem;
  cursor: pointer;
  border-radius: 8px;
  font-size: 14px;

  &:hover {
    background-color: ${(p) => p.theme.colorNeutrals600}30;
  }
`

export const Cell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 12rem;
`

export const RightCell = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  white-space: nowrap;
`

export const RowMenuPanel = styled.div`
  display: flex;
  flex-direction: column;
  user-select: none;
  max-height: 12.5rem;
  border: 1px solid ${(p) => p.theme.colorDividerDefault};
  background-color: ${(p) => p.theme.colorSurfaceBase};
  padding: 0.625rem;
  width: 10rem;
  border-radius: 12px;
  ${(p) => p.theme.content};
`

export const RowMenuOption = styled.div`
  cursor: pointer;
  height: 2.5rem;
  display: flex;
  align-items: center;
  gap: 0.625rem;
  border-radius: 8px;
  padding: 0 0.5rem;

  &:hover {
    background-color: ${(p) => p.theme.colorNeutrals600};
  }

  p {
    font-size: 12px;
    line-height: 16px;
  }
`
